import axios from "axios";

const apiUrl = process.env.REACT_APP_API_URL;

export const showcaseSponsors = async () => {
  try {
    const response = await axios.get(
      `${apiUrl}/api/announcements/sponsor-showcase/all/`,
    );
    return response.data;
  } catch (error) {
    console.error("Error:", error);
    throw error;
  }
};
